module.exports = __webpack_public_path__ + "static/media/clubnsociety.de464a65.png";